import React, { useEffect, useState } from "react";
import MainLayout from "../../components/common/layout/main/MainLayout";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import withAuth from "../../hocs/withAuth";
import { GroupType } from "../../types/group.type";
import { groups } from "../../utils/group";
import GroupBase from "./GroupBase";

function GroupPage() {
  const { code } = useParams();
  const [group, setGroup] = useState<GroupType>();

  useEffect(() => {
    if (code) {
      const currentCate = groups[code];
      setGroup(currentCate);
    }
  }, [code]);

  return (
    <MainLayout>
      {group ? (
        <GroupBase group={group} />
      ) : (
        <Typography sx={{ textAlign: "center", fontSize: "20px" }}>
          Báo cáo không tồn tại
        </Typography>
      )}
    </MainLayout>
  );
}

export default withAuth(GroupPage);
